export const onMouseDown = ({
  hotspotType,
  drawing,
  startXY,
  root,
  inverseScale,
  rectState,
  pubSub,
}) => {
  return e => {
    if (hotspotType !== 'rectangle') {
      return;
    }

    drawing.current = true;
    startXY.current = {
      startX:
        (e.clientX - root.current!.getBoundingClientRect().left) * inverseScale,
      startY:
        (e.clientY - root.current!.getBoundingClientRect().top) * inverseScale,
    };

    rectState.current = {
      x: 0,
      y: 0,
      w: 0,
      h: 0,
    };

    pubSub.publish('UPDATE_HOTSPOT_POINTS', rectState.current);
  };
};
